import CryptoJS from 'crypto-js';

/**
 * @param {string} secret - Secret used to generate hash key.
 * @param {string} value - Value to be signed. Must be ASCII.
 *
 * @return {string}
 * @ignore
 */
const sign = (secret: string, value: string): string => {
  const signature = CryptoJS.HmacSHA256(secret, value);

  return signature.toString();
};

/**
 * @param {string} secret - Secret used to generate hash key.
 * @param {string} signature - Signature on value to be verified.
 * @param {string} value - Value to be verified. Must be ASCII.
 *
 * @return {boolean} - True if signatures match and false if they don't
 * @ignore
 */
const verify = (secret: string, signature: string, value: string): boolean => {
  const signature2 = CryptoJS.HmacSHA256(secret, value);

  return signature.toString() === signature2.toString();
};

/**
 * Takes an array of char codes and performs a bitwise
 * XOR.
 *
 * @param {array} input Array of char codes
 * @return string
 * @ignore
 */
const deobfuscate = (input: number[]): string => {
  let result = '';
  for (const val of input) {
    const a = val;
    // tslint:disable-next-line:no-bitwise
    const b = a ^ 0x7e;
    result = result + String.fromCharCode(b);
  }

  return result;
};

export const securityUtils = {
  sign,
  verify,
  deobfuscate,
};
